


















import Vue from 'vue'
export default Vue.extend({
  props: {
    value: {
      type: [String, Number, Boolean],
    },
    variable: {
      type: String,
    },
    description: {
      type: String,
    },
  },
})
